import {
    useState,
    useCallback,
} from 'react';
import axios from 'axios';
import { useRecoilState } from 'recoil';
import { addressesState } from 'store/state';
import toastAlert from 'components/UI/Alert';
import { FST_DISTRIBUTION_EVENTS } from '_constants/apiEndpoints';

const useAllocationHistory = () => {
    const [isLoading, setLoading] = useState(false);
    const [addresses] = useRecoilState(addressesState);

    const getHistory = useCallback(async (isCustom, offset = 0, limit = 20, filterDate) => {
        try {
            setLoading(true);
            const response = await axios({
                method: 'post',
                url: FST_DISTRIBUTION_EVENTS,
                data: {
                    distributionAddress: isCustom ? addresses.customDistribution : addresses.distribution,
                    offset,
                    limit,
                    from: filterDate ? filterDate[0] : null,
                    to: filterDate ? filterDate[1] : null,
                },
            });

            return response;
        } catch (err) {
            toastAlert({
                type: 'error',
                customMessage: err,
            });
            console.error('useAllocationHistory service error:', err);
            throw err;
        } finally {
            setLoading(false);
        }
    }, [addresses.customDistribution, addresses.distribution]);

    return {
        isLoading,
        getHistory,
    };
};

export default useAllocationHistory;
